import { Tooltip } from 'antd';
import React from 'react';
import { useAppSelector } from 'shared/store';
import { selectActiveOrg } from 'shared/store/auth-slice';
import HIPAAModeIcon from 'shared/assets/images/hipaa-mode-icon.svg';
import './style.less';

export const HIPAAIndicator: React.FC = () => {
  const isHippa = useAppSelector(selectActiveOrg)?.hippaMode;
  if (!isHippa) {
    return null;
  }

  return (
    <div className="HIPAAIndicator">
      <Tooltip placement="right" title="HIPAA Compliant">
        <div className="HIPAAIndicator__icon">
          <HIPAAModeIcon />
        </div>
      </Tooltip>
    </div>
  );
};
